import React from "react";
import Box from "@mui/material/Box";
import {Button} from "@mui/material";
import axios from "axios";
import {getUrl} from "../requests";
import './ZapleczeHeader.css';
import css from './ZapleczeHeader.module.css';
import clsx from "clsx";

export const ZapleczeHeader = ({
    pageTitle,
    children=""
}) => {

    const handleFileDownloadAndOpen = async () => {
        try {
            const response = await axios.get(`${getUrl()}/api/v1/provider/download-help-file`, {
                responseType: "blob"
            });

            const blobObj = new Blob([response.data], { type: "application/pdf" });

            const url = window.URL.createObjectURL(blobObj);

            window.open(url, "_blank");

            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Błąd pobierania pliku:", error);
            alert("Błąd podczas pobierania pliku. Spróbuj ponownie.");
        }
    };

    return (
        <Box className={clsx(css.headerPanel)}>
            <Box className={clsx(css.headerTitle)}>
                <Box className={clsx(css.headerLabel)}>
                    Aktywny panel:
                </Box>
                <Box className={clsx(css.headerName)}>
                    {pageTitle}
                </Box>
            </Box>
            <Box className={clsx(css.headerElement)}>
                {children}
            </Box>
            <Box className={clsx(css.instrukcja)}>
                <Button className={clsx(css.btn)}
                        onClick={handleFileDownloadAndOpen}
                >
                    Instrukcja
                </Button>
            </Box>
        </Box>
    )
}